import {
  FETCH_OPERATOR_DETAILS,
  FETCH_OPERATOR_DETAILS_SUCCESS,
  FETCH_MODE_SUCCESS
} from "./actions/constants";

import { SELECTED_OPERATORS } from "containers/BuyOperatorToken/actions/constants";

const saveOperators = JSON.parse(sessionStorage.getItem("selectedOperators"));
const initialState = {
  operators: [],
  filterSelected: [],
  mode: [],
  loading: false,
  selectedOperators: saveOperators != null ? saveOperators : [],
  isSelectAll: false
};

function selectOperatorTokenReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_OPERATOR_DETAILS: {
      return {
        ...state,
        loading: true
      };
    }
    case FETCH_OPERATOR_DETAILS_SUCCESS: {
      return {
        ...state,
        loading: false,
        operators: action.payload,
        filterSelected: action.payload
      };
    }
    case FETCH_MODE_SUCCESS: {
      return {
        ...state,
        loading: false,
        mode: action.payload
      };
    }

    case SELECTED_OPERATORS: {
      sessionStorage.setItem(
        "selectedOperators",
        JSON.stringify(action.payload)
      );
      return {
        ...state,
        loading: false,
        selectedOperators: action.payload
      };
    }

    default:
      return state;
  }
}

export default selectOperatorTokenReducer;
